import { enumToOptions } from '@libs/types/src/common/enum/util';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';

export enum FolderDashboardWidgetsEnum {
    PERSON_INFO = 'personInfo',
    IMPORTANT_INFO = 'importantInfo',
    HISTORY = 'history',
    SERVICE_RECORD = 'serviceRecord',
    EPICRISIS = 'epicrisis',
    PERSON_NOTE = 'personNote',
    ERRORS_IN_FOLDER = 'errorsInFolder',
    RISKY_CLIENT = 'riskyClient',
    SHARE_DATA_WITH_SERVICE = 'shareDataWithService',
    PALLIATIVE_CARE = 'palliativeCare',
    CURRENT_MEDICATION = 'currentMedication',
    VISIT_RECORDS = 'visitRecords',
    MEASURED_VALUES = 'measuredValues',
    LAST_CONTINUOUS_RECORD = 'lastContinuousRecord',
    MOVEMENT_RESTRICTION = 'movementRestriction',
    BILLING_STATUS = 'billingStatus',
    PROTOCOLS = 'protocols',
    PLANS = 'plans',
    ANAMNESIS = 'anamnesis',
}

const commonWidgetsToShare: readonly FolderDashboardWidgetsEnum[] = [
    FolderDashboardWidgetsEnum.PERSON_NOTE,
    FolderDashboardWidgetsEnum.RISKY_CLIENT,
];

const widgetsToShareByServiceType: Record<ServiceTypeEnum, readonly FolderDashboardWidgetsEnum[]> = {
    [ServiceTypeEnum.HEALTH_CARE]: [
        ...commonWidgetsToShare,
        FolderDashboardWidgetsEnum.VISIT_RECORDS,
    ],
    [ServiceTypeEnum.SOCIAL]: [
        ...commonWidgetsToShare,
        FolderDashboardWidgetsEnum.PROTOCOLS,
        FolderDashboardWidgetsEnum.PLANS,
    ],
};

export const folderDashboardWidgetsEnumOptions = enumToOptions(FolderDashboardWidgetsEnum, 'enum.folderDashboardWidgets.');

export function getFolderDashboardWidgetsEnumOptionsToShare(serviceType: string | null | undefined) {
    const widgetsToShare = serviceType === ServiceTypeEnum.HEALTH_CARE || serviceType === ServiceTypeEnum.SOCIAL
        ? widgetsToShareByServiceType[serviceType]
        : [];

    return folderDashboardWidgetsEnumOptions
        .filter((option) => widgetsToShare.includes(option.value as FolderDashboardWidgetsEnum));
}
